import { SHELL } from '../shell/shell.const';

const MORAL_ONBOARDING = 'reg-moral';

const MORAL_ONBOARDING_STEP_1 = 'documentos-generales';
const MORAL_ONBOARDING_STEP_2 = 'datos-generales';
const MORAL_ONBOARDING_STEP_3 = 'informacion';
const MORAL_ONBOARDING_STEP_4 = 'direccion';
const MORAL_ONBOARDING_STEP_5 = 'contrato';

export const MORAL_ONBOARDING_ROUTES = {
    MORAL_ONBOARDING,
    MORAL_ONBOARDING_STEP_1,
    MORAL_ONBOARDING_STEP_2,
    MORAL_ONBOARDING_STEP_3,
    MORAL_ONBOARDING_STEP_4,
    MORAL_ONBOARDING_STEP_5,

    ROUTE_MORAL_ONBOARDING_STEP_1: `${SHELL}/${MORAL_ONBOARDING}/${MORAL_ONBOARDING_STEP_1}`,
    ROUTE_MORAL_ONBOARDING_STEP_2: `${SHELL}/${MORAL_ONBOARDING}/${MORAL_ONBOARDING_STEP_2}`,
    ROUTE_MORAL_ONBOARDING_STEP_3: `${SHELL}/${MORAL_ONBOARDING}/${MORAL_ONBOARDING_STEP_3}`,
    ROUTE_MORAL_ONBOARDING_STEP_4: `${SHELL}/${MORAL_ONBOARDING}/${MORAL_ONBOARDING_STEP_4}`,
    ROUTE_MORAL_ONBOARDING_STEP_5: `${SHELL}/${MORAL_ONBOARDING}/${MORAL_ONBOARDING_STEP_5}`,

}